import { addTrackingHash as o, removeTrackingHash as t } from "./index118.mjs";
import { useEffect as c } from "react";
const n = (r, e) => {
  c(() => (o(r, e), () => t()), [e, r]);
};
export {
  n as useTracking
};
